import {agGridListingController} from './ag-grid-listing.ctrl'

const agGridListing = () => {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      gridName: '=',
      gridOptions: '=',
      helpTooltip: '=',
      filterCount: '=',
      gridActionsDirective: '=',
      activeActions: '=',
      actionsFunctions: '=',
      gridDataActions: '=',
      multipleSelectionActions: '=',
      multiSelectOptions: '=',
      groupList: '=',
      isAllowedAgent: '=',
      showCv: '=',
      halfGrid: '&',
      hierarchialApplicationStages: '=',
      allApplicationStagesList: '=',
      updateDropDownStages: '&',
      innerHeight: '=',
    },
    controller: agGridListingController,
    template: require('./ag-grid-listing.html'),
  }
}

angular.module('app.directives').directive('agGridListing', agGridListing)



// WEBPACK FOOTER //
// ./scripts/shared/directives/ag-grid-listing/ag-grid-listing.directive.js